/* eslint-disable default-param-last */
export const localizationReducer = (state = null, action) => (action.type === 'SET_LOCALIZATION' ? action.payload : state);
